import {createWebHistory,createRouter} from  'vue-router'

const routes = [
    { path: '/main',name:'main',component:()=> import('@/pages/order/MyIndex.vue') },
    { path: '/',name:'admin',redirect:'/order/my/index' },

    { path: '/login',name:'login',component: ()=> import('@/pages/Login.vue'),meta:{title:'登录'} },
    { path: '/register',name:'register',component:()=> import('@/pages/Register.vue'),meta:{title:'注册'} },
    { path: '/order/my/index',name:'OrderMyIndex', component:()=> import('@/pages/order/MyIndex.vue') ,meta:{title:'我的订单',keep_alive:true} },
    { path: '/order/add',name:'OrderAdd', component:()=> import('@/pages/order/Add.vue') ,meta:{title:'添加订单'} },
    { path: '/finance/statistics',name:'FinanceStatistics', component: ()=>import('@/pages/finance/statistics.vue') ,meta:{title:'财务统计',keep_alive:true} },
    { path: '/user/info',name:'UserInfo', component: ()=>import('@/pages/user/Info.vue') ,meta:{title:'账号信息',keep_alive:true} },
    { path: '/check',name:'checkreport',component:()=> import('@/pages/Check.vue'),meta:{title:'报告真实性校验'} },
    { path: '/verify',name:'verifyreport',component:()=> import('@/pages/Verify.vue'),meta:{title:'Report Authenticity Verification'} },
    //{ path: '/test',name:'test',component:()=> import('@/pages/test.vue'),meta:{title:'测试'} },
    { path: '/:pathMatch(.*)',name: 'NotFound',component:()=> import('@/pages/error/404.vue'),meta: { title: '404'}},
]

const asyncRoutes = []



export const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_PATH),
    routes
})

export const addRoutes = (routesArray)=>{
    let hasNewMenu = false;
    function addRoutesFromMenus (menus){
            menus.forEach(menu=>{
                let route = asyncRoutes.find(r=>r.path === menu.front_path)

                if(route && !router.hasRoute(route.name)){
                    console.log('add route：',route)
                    router.addRoute('admin',route)
                    hasNewMenu = true;
                }
        })
    }
    //console.log('+++++++routesArray:',routesArray);
    addRoutesFromMenus(routesArray)
    return hasNewMenu;
}